import {Card, Grid, Typography} from "@mui/material";
import {styled} from '@mui/material/styles';
import chroma from "chroma-js";
import {FC} from "react";
import {ClimbingRoute} from "../../models/ClimbigRoute";
import {Difficulty} from "../../models/ClimbingEvent";
import {CustomColorBadge} from "../CustomBadge/CustomColorBadge";
import {StatusLabelAndColour} from "../../models/UserClimbingEvent";
import {GridItem} from "./GridItem";

const blockSize: number = 50;

const Item = styled(Card)(({theme}) => ({
  padding: theme.spacing(1.5),
  textAlign: 'center',
  variant: "outlined",
  width: blockSize,
  height: blockSize,
}));

type Props = {
  routes: ClimbingRoute[],
  dificulties: Difficulty[],
  handleMenu: (event: React.MouseEvent<HTMLElement>, id?: number) => void,
  addNewRouteButton: boolean,
  getColorForId?: (id: number) => StatusLabelAndColour | undefined,
  routesToNrOfClimbes?: Map<number, number>
  hideDificulty?: boolean
}

export const RoutesGrid: FC<Props> = ({
                                        routes,
                                        dificulties,
                                        handleMenu,
                                        getColorForId,
                                        addNewRouteButton,
                                        routesToNrOfClimbes,
                                        hideDificulty = false
                                      }) => {

  const getTextColor = (color: string) => chroma(color).luminance() > 0.5 ? "black" : "white";
  return (
    <Grid container spacing={0.5}>
      {routes.map((route, index) => (
        <Grid item key={"eventRoute-" + index} xs={4} md={3}>

          <CustomColorBadge backgroudColor={dificulties.find((d) => d.difficulty === route.dificulty)?.colour}
                            badgeContent={route.dificulty} hidden={hideDificulty}>
            <Item sx={
              getColorForId ? {
                backgroundColor: getColorForId(route.id)?.color || "white",
                color: getTextColor(getColorForId(route.id)?.color || "white")
              } : {}
            } onClick={(event) => handleMenu(event, route.id)}>
              <GridItem id={route.id} statusLabelAndColour={getColorForId ? getColorForId(route.id) : undefined}/>
            </Item>
          </CustomColorBadge>
        </Grid>
      ))}
      {addNewRouteButton &&
          <Grid item xs={3} md={2}>
              <Item onClick={(event) => handleMenu(event)} color="primary">
                  <Typography variant='h6' sx={{lineHeight: `${blockSize}px`}}>+</Typography>
              </Item>
          </Grid>
      }
    </Grid>
  )
}